import { render, staticRenderFns } from "./GradeFeeEdit.vue?vue&type=template&id=433653fd"
import script from "../../controllers/grade_fee/grade-fee-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/grade_fee/grade-fee-edit.js?vue&type=script&lang=js&external"
import style0 from "./GradeFeeEdit.vue?vue&type=style&index=0&id=433653fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports